import dayjs from 'dayjs';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { GeneratedField } from 'src/pages/CompanyPage/_BLL/types';
import { toDenominatorDateFormat } from 'src/shared/lib/date';
import { DatePicker } from 'src/shared/ui/inputs/DatePicker';
import s from './DateField.module.scss';
import { Tooltip } from 'src/shared/ui/_tooltips/Tooltip';

export const DateField: React.FC<Omit<GeneratedField, 'validate'>> = (props) => {
	const {
		namePrefix, //
		propertyName,
		internalName,
		measureUnits,
	} = props;

	// * Form
	const { setValue, control } = useFormContext();

	const name = `${namePrefix}${propertyName}.${internalName}`;
	const VALUE_NAME = `${name}.value`;

	const textFieldOnChangeHandler = (date: string | null) => {
		if (date === null) {
			setValue(VALUE_NAME, null);
		} else {
			setValue(VALUE_NAME, date);
		}
	};

	// * Render
	return (
		<Controller
			name={VALUE_NAME}
			control={control}
			render={({ field, fieldState }) => (
				<Tooltip title={field.value}>
					<div className={s.fieldWrapper}>
						<DatePicker
							{...field}
							className={s.datePicker}
							value={field.value ? dayjs(field.value) : undefined}
							onChange={(date) => textFieldOnChangeHandler(date === null ? null : toDenominatorDateFormat(date.toDate()))}
							error={fieldState.error?.message}
							size="middle"
						/>

						{measureUnits && <span className={s.additionalTextRight}>{measureUnits}</span>}
					</div>
				</Tooltip>
			)}
		/>
	);
};
